import styled from 'styled-components'
import {Button} from '@components/lib'

export const Description = styled.p`
  color: ${({theme}) => theme.colors.textPrimary};
  font-weight: 400;
  font-size: ${({theme}) => theme.fontSizes.small};
`

export const ButtonBottom = styled(Button)`
  margin-top: 15px;
`
